module.exports = __webpack_public_path__ + "img/3.47e107d5.jpg";